module.exports = __webpack_public_path__ + "static/media/pennant.3d675ee9.svg";